<template>
  <v-container>
    <v-btn small text outlined @click.stop="navigateBack()">
      <v-icon small>mdi-arrow-left</v-icon>
      <span class="body-2 font-weight-medium">Searches</span>
    </v-btn>
    <v-data-table :headers="headers" :items="searchListings" sort-by="end_time" sort-desc>
      <!-- <template v-slot:item.item_id="{ item }"><a href=`${item.item_url}` target="_blank">{{ id }}</a></template> -->
      <template v-slot:item.item_id="{ item }"><a :href="item.item_url" target="_blank" style="text-decoration: none;">{{ item.id }}</a></template>
      <template v-slot:item.end_time="{ item }">{{ itemEndDateTime(item.end_time) }}</template>
      <template v-slot:item.item_descr="{ item }"><span class="heading">{{ item.item_descr }}</span></template>
      <template v-slot:item.item_price="{ item }">{{ itemPrice(item) }}</template>
    </v-data-table>
  </v-container>
</template>

<script>
// import searchListings from '@/assets/single_search_listings.json'
// import getSalePrice from "../../src/utilities.js"
// import setDateTimeFormat from "../../src/utilities.js"

export default {
  name: "Listings",
  props: {
    searchId: {
      type: Number
    }
  },
  data() {
    return {
      searchListings: [],
      headers: [
        {
          text: "Item",
          align: "center",
          value: "item_id"
        },
        /* {
          text: 'Start Time',
          align: 'center',
          sortable: true,
          value: 'start_time'
        }, */
        {
          text: "Ending",
          align: "center",
          value: "end_time"
        },
        {
          text: "Description",
          align: "start",
          value: "descr"
        },
        {
          text: "Price",
          align: "end",
          value: "item_price"
        }
      ]
    }
  },
  computed: {
    /* searchListings () {
      return searchListings
    } */
  },
  methods: {
    navigateBack() {
      // this.searchId = -1
      this.$emit("searchSelected", -1)
    },
    /* itemTitle (item) {
      return item.item.title[0]
    }, */
    itemPrice(item) {
      // console.log(item) // debug
      // let listingInfo = item.item.listingInfo[0]
      // let binFlag = item.listing_info[0].buyItNowAvailable[0]
      // console.log(binFlag) // debug
      let itemPrice = ""

      if (item.listing_info[0].hasOwnProperty("buyItNowPrice")) {
        itemPrice = item.listing_info[0].buyItNowPrice[0].__value__
      } else {
        itemPrice = item.selling_status[0].currentPrice[0].__value__
      }

      let priceSplits = itemPrice.split(".")
      if (priceSplits[1].length === 1) {
        priceSplits[1] = `${priceSplits[1]}0`
      }
      return `$${priceSplits[0]}.${priceSplits[1]}`
      // return getSalePrice(item)
    },
    setDateTimeFormat(stringDateTime) {
      let gmtDateTime = new Date(stringDateTime)
      let localDateTime = `${gmtDateTime.toLocaleDateString("en-US")} ${gmtDateTime.toLocaleTimeString("en-US")}`
      return localDateTime
    },
    itemStartDateTime(item) {
      let listingInfo = item.item.listingInfo
      return this.setDateTimeFormat(listingInfo[0].startTime[0])
    },
    itemEndDateTime(endTime) {
      // console.log(endTime) debug
      // let listingInfo = item.item.listingInfo
      return this.setDateTimeFormat(endTime)
    }
  },
  mounted() {
    let self = this
    // console.log(this.searchId) // debug
    let userId = this.$store.state.userId
    let url = `${process.env.VUE_APP_API_ROOT_URL}results/`
    // console.log(`URL: ${url}`) // debug
    let params = {
      resource: "results",
      action: "single",
      variables: {
        search_id: this.searchId,
        user_id: userId
      }
    }

    this.axios.post(url, params)
    .then (function storeListings (response) {
      let listings = response.data
      self.searchListings = listings
    })
  }
}
</script>

<style scoped>

</style>
